import * as React from "react";

const Store = React.createContext(null);

Store.displayName = "Store";

export const StoreProvider = ({ children, initialState, reducer }) => {
  const [globalState, dispatch] = React.useReducer(reducer, initialState);

  return (
    <Store.Provider value={[globalState, dispatch]}>{children}</Store.Provider>
  );
};

export const useStore = () => {
  const [state, dispatch] = React.useContext(Store);

  const tabData = state && state.tabData ? state.tabData : {};
  const updatedValues = state && state.updatedValues ? state.updatedValues : {};
  const skills = state && state.skills ? state.skills : [];
  const settings = state && state.settings ? state.settings : {};
  const microSites = state && state.microSites ? state.microSites : {};
  const microSiteActions =
    state && state.microSiteActions ? state.microSiteActions : {};
  const activePartner =
    state && state.activePartner
      ? state.activePartner
      : { id: null, mediaLink: null };

  return {
    dispatch,
    tabData,
    updatedValues,
    skills,
    settings,
    microSites,
    microSiteActions,
    activePartner,
  };
};
